import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import { Box, Button, Alert, Snackbar } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, get } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import DynamicTable from "../../../../Components/Common/DynamicTable";
import { validateLeadershipTable, validateTable } from "../../../../utils/validateTable";
import { restructureData } from "../../../../utils/restructureData";
import CustomTextField from "../../GRI300/GRI308/CustomTextField";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import SectionHeading from "../../GRI300/GRI308/SectionHeading";

const GRI203_2 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    alignmentWithExternal: "",
  });
  const [griReview, setGriReview] = useState(() =>
    JSON.parse(localStorage.getItem("griReview"))
  );

  const inputData = [
    {
      fieldName: "examplesOfIndirectEconomicImpacts",
      title:
        "a. Provide examples of significant indirect economic impacts attributable to the organization, highlighting both positive and negative effects. This may include changes in productivity across organizations or sectors, economic development in impoverished areas, impacts of social or environmental conditions, accessibility of products and services for low-income individuals, employment effects within the supply or distribution chain, influences on foreign direct investment, changes resulting from operational or activity relocation, and economic outcomes from product or service utilization",
      fields: [
        {
          fieldName: "impact",
          title:
            "Significant indirect economic impacts attributable to the organization",
          type: "text",
          placeholder: "Enter Text",
          width: "38%",
        },
        {
          fieldName: "positiveImpact",
          title: "Positive Impact",
          type: "text",
          placeholder: "Enter Text",
          width: "20%",
        },
        {
          fieldName: "negativeImpact",
          title: "Negative Impact ",
          type: "text",
          placeholder: "Enter Text",
          width: "20%",
        },
      ],
    },
  ];

  const [tables, setTables] = React.useState([]);

  const [data, setData] = useState({});
  const [tabErrors, setTabErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(`/gri/get?type=GRI200&Id=${id}`);
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        const data1 = response.data.data.GRI200 || {};
        setData(data1);
        setFormData({
          alignmentWithExternal: data1.alignmentWithExternal || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    if (!formData.alignmentWithExternal) {
      newErrors.alignmentWithExternal = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // const isFormValid = validateForm();
      const isTableValid = validateLeadershipTable(inputData, tables, setTabErrors);

      if (!isTableValid) {
        return;
      }

      let transformedData = restructureData(tables);

      const payload = {
        type: "GRI200",
        submitted203_2: true,
        ...transformedData,
        ...formData,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`/gri/update?Id=${id}`, payload);
        navigate(`/gri/economic-performance/204-1/${id}`);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/economic-performance/204-1/${id}`);
    }
  };
  const renderContent = ({ hide }) => (
    <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      {!hide && (
        <p className={styles.section_heading}>203 : Indirect Economic Impact</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1.5rem" : "0" }}
      >
        203-2 : Significant indirect economic impacts
      </p>
      {/* Section A */}

      <DynamicTable
        inputData={inputData}
        tables={tables}
        data={data}
        setTables={setTables}
        disabled={disabled}
        errors={tabErrors}
        setErrors={setTabErrors}
        hide={hide}
      />

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section B */}
        <SectionHeading text="b. In the context of external benchmarks and stakeholder priorities such as national and international standards, protocols, and policy agendas, please assess the significance of the indirect economic impacts generated by the organization. Consider the spectrum of indirect economic effects outlined in the guidance, and evaluate how these impacts align with established benchmarks and stakeholder priorities." />
        <CustomTextField
          value={formData.alignmentWithExternal}
          onChange={(e) =>
            handleInputChange("alignmentWithExternal", e.target.value)
          }
          error={errors.alignmentWithExternal}
          helperText={errors.alignmentWithExternal}
          disabled={disabled}
        />

        {/* Submit Button */}

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                  onClick={handleSubmit}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI203_2;
